/* tslint:disable */
/* eslint-disable */
/**
 * ファイル管理ポータル クライアントAPI
 * ファイル管理ポータル Webクライアント向けAPI 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: TODO@graat.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { CommonManagementNotRequiredFlag } from './common-management-not-required-flag';

/**
 * メインメニューアイテム共有モデル
 * @export
 * @interface MainMenuItemCommonModel
 */
export interface MainMenuItemCommonModel {
    /**
     * メインメニューアイテムID
     * @type {string}
     * @memberof MainMenuItemCommonModel
     */
    'main_menu_item_id'?: string;
    /**
     * メインメニューアイテムタイプコード - MT1:小見出し - MT2:テキスト - MT3:URL - MT4:保存済み検索条件 - MT5:内容タグ(フォルダ) - MT6:データラック(ファイル) 
     * @type {string}
     * @memberof MainMenuItemCommonModel
     */
    'main_menu_item_type_code': MainMenuItemCommonModelMainMenuItemTypeCodeEnum;
    /**
     * メインメニューID
     * @type {string}
     * @memberof MainMenuItemCommonModel
     */
    'main_menu_id'?: string;
    /**
     * 表示順
     * @type {number}
     * @memberof MainMenuItemCommonModel
     */
    'display_order'?: number;
    /**
     * 内容タグID
     * @type {string}
     * @memberof MainMenuItemCommonModel
     */
    'content_tag_id'?: string;
    /**
     * 
     * @type {CommonManagementNotRequiredFlag}
     * @memberof MainMenuItemCommonModel
     */
    'common_management_flag'?: CommonManagementNotRequiredFlag;
    /**
     * DC管理コード
     * @type {string}
     * @memberof MainMenuItemCommonModel
     */
    'dc_management_code'?: string;
    /**
     * Viewコード
     * @type {string}
     * @memberof MainMenuItemCommonModel
     */
    'view_code'?: string;
    /**
     * データラックID
     * @type {string}
     * @memberof MainMenuItemCommonModel
     */
    'data_rack_id'?: string;
    /**
     * 検索条件ID
     * @type {string}
     * @memberof MainMenuItemCommonModel
     */
    'search_criteria_id'?: string;
    /**
     * ファイルサービス左ペイン開閉制御区分<br> メインメニューアイテムタイプコードが「MT5:内容タグ(フォルダ)」「MT6:データラック(ファイル)」以外の場合は「NONE」をセットする。 - OPEN: 左ペインを開く - CLOSE: 左ペインを閉じる - NONE: 制御不可 
     * @type {string}
     * @memberof MainMenuItemCommonModel
     */
    'file_service_left_pain_control_type'?: MainMenuItemCommonModelFileServiceLeftPainControlTypeEnum;
    /**
     * URL
     * @type {string}
     * @memberof MainMenuItemCommonModel
     */
    'url'?: string;
}

export const MainMenuItemCommonModelMainMenuItemTypeCodeEnum = {
    Mt1: 'MT1',
    Mt2: 'MT2',
    Mt3: 'MT3',
    Mt4: 'MT4',
    Mt5: 'MT5',
    Mt6: 'MT6'
} as const;

export type MainMenuItemCommonModelMainMenuItemTypeCodeEnum = typeof MainMenuItemCommonModelMainMenuItemTypeCodeEnum[keyof typeof MainMenuItemCommonModelMainMenuItemTypeCodeEnum];
export const MainMenuItemCommonModelFileServiceLeftPainControlTypeEnum = {
    Open: 'OPEN',
    Close: 'CLOSE',
    None: 'NONE'
} as const;

export type MainMenuItemCommonModelFileServiceLeftPainControlTypeEnum = typeof MainMenuItemCommonModelFileServiceLeftPainControlTypeEnum[keyof typeof MainMenuItemCommonModelFileServiceLeftPainControlTypeEnum];


